import React, { useState } from 'react';
import { Button } from './ui/button.tsx';
import { Input } from './ui/input.tsx';
import { LogoLarge } from './LandingPageIcons.tsx';

interface PasswordGateProps {
  onUnlock: () => void;
}

export function PasswordGate({ onUnlock }: PasswordGateProps) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password.toUpperCase() === 'FREAK') {
      onUnlock();
    } else {
      setError(true);
    }
  };

  return (
    <div className="loyal-freaks  min-h-screen bg-[#625de4] flex flex-col items-center justify-center p-4 relative overflow-hidden">
      {/* Background elements to match theme */}
      <div className="absolute inset-0 pointer-events-none opacity-20">
        <div className="absolute top-10 left-10 w-32 h-32 bg-[#ffbf00] rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-48 h-48 bg-[#ed196f] rounded-full blur-3xl"></div>
      </div>

      <div className="bg-white !border-4 !border-black !border-solid rounded-[30px] shadow-[10px_10px_0px_0px_black] p-8 md:p-12 w-full max-w-md relative z-10">
        <div className="flex justify-center mb-6">
          <LogoLarge className="w-[180px] md:w-[220px] h-auto" />
        </div>
        <p className="text-center text-black-600 mb-8 font-bold uppercase tracking-wide">
          THIS ISN'T FOR EVERYONE!
        </p>
        <p className="text-center text-gray-600 mb-8 font-bold uppercase tracking-wide">
          It’s here because you’ve been part of Freaks of Nature since the beginning.
        </p>

        <form onSubmit={handleSubmit} className="flex flex-col gap-6">
          <div className="space-y-2">
            <Input
              type="password"
              placeholder="ENTER PASSWORD"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setError(false);
              }}
              className={`text-center text-xl font-bold uppercase border-2 h-14 ${error ? 'border-red-500 bg-red-50' : 'border-black'}`}
            />
            {error && (
              <p className="text-red-600 text-sm font-bold text-center uppercase animate-pulse">
                Incorrect Password
              </p>
            )}
          </div>

          <div className="relative group cursor-pointer w-full">
            <div className="absolute inset-0 bg-black rounded-[10px] translate-x-[4px] translate-y-[4px]"></div>
            <Button
              type="submit"
              className="w-full relative bg-[#ED196F] hover:bg-[#d01660] border-2 border-black rounded-[10px] h-14 text-white font-black text-xl uppercase tracking-wider transition-transform active:translate-x-[2px] active:translate-y-[2px]"
            >
              Enter
            </Button>
          </div>
        </form>


      </div>
    </div>
  );
}
